import { API } from "../config";
import { serverAPIPath } from "../components/Auth/config/apiPath";
import AxiosUtils from "./AxiosUtils";
import Cookies from "./Cookies";
 
class GoogleMapServices {
 
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;
    then: any;
    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = {"access-token": new Cookies("access-token").read() };
    }
 
    async getAddressByZipCode(zipcode: string, selectedLang: string) {
        const lang = selectedLang === "jp" ? "ja" : "en";
        const response = await new AxiosUtils(
            `${API.BASE_URL}${serverAPIPath.GOOGLE_AUTH}?zipCode=${zipcode}&lang=${lang}`,
            this.payload,
            this.headers
        ).getNew();
        if(response?.data?.success==true) {
            return response?.data?.data?.results;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }
}

export default GoogleMapServices;